// 系统设置
//系统设置-用户设置
const accountSet = () => import( /* webpackChunkName: "basic" */ '@/pages/systemSet/views/accountSet.vue')
//系统设置-微信设置
const wechatSet = () => import( /* webpackChunkName: "basic" */ '@/pages/systemSet/views/wechatSet.vue')

const systemSet = [
  {
    path: 'accountSet',
    name: 'accountSet',
    component: accountSet
  },
  {
    path: 'wechatSet',
    name: 'wechatSet',
    component: wechatSet
  },
]

export default systemSet
